import RCAStatusBadge from "pages/Corporate/RCA/components/RCAStatusBadge";
import { useStyles } from "./ActionPlanStatusCell.styles";
import { useTranslation } from "react-i18next";
import { DefaultTranslationFieldsInTable } from "constants/constants";
import { IActionPlanStatusCell } from "./ActionPlanStatusCellInterfaces";
import { translateDefaultEntity } from "utilities/localesUtilities";

const ActionPlanStatusCell = ({ actionPlan, myDashboard }: IActionPlanStatusCell) => {
    const classes = useStyles();
    const { i18n } = useTranslation();
    return (
        <div className={myDashboard ? classes.myDashboardWrapper : classes.wrapper}>
            <div className={classes.statusWrapper}>
                <RCAStatusBadge
                    status={actionPlan.status.status_id as unknown as number}
                    className={classes.statusBadge}
                />{" "}
                <span>
                    {translateDefaultEntity(
                        i18n.language,
                        actionPlan.status,
                        "name",
                        DefaultTranslationFieldsInTable.STATUS,
                    )}
                </span>
            </div>
        </div>
    );
};

export default ActionPlanStatusCell;
